import axios from "axios";
import { getApiUrl } from "@/Utils/api-url-helper";

const timeRange = {
  weeks: "WEEKS_4",
  months: "MONTHS_3",
  all: "ALL_TIME",
};

function paramsWithStudent(rangeOrEmpty, forStudentId) {
  const p = rangeOrEmpty != null ? { range: timeRange[rangeOrEmpty] } : {};
  if (forStudentId != null && forStudentId !== "") {
    p.forStudentId = forStudentId;
  }
  return p;
}

export async function getAccuracyKpi(range, forStudentId = null) {
  return axios
    .get(`${import.meta.env.VITE_API_BASE_URL}/api/stat/accuracy-kpi`, {
      params: paramsWithStudent(range, forStudentId),
    })
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

export async function getAnsweredCountKpi(range, forStudentId = null) {
  const apiBaseUrl = getApiUrl(import.meta.env.VITE_API_BASE_URL);
  return axios
    .get(`${apiBaseUrl}/api/stat/attempts-kpi`, {
      params: paramsWithStudent(range, forStudentId),
    })
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

export async function getCurrentStreakKpi(forStudentId = null) {
  const apiBaseUrl = getApiUrl(import.meta.env.VITE_API_BASE_URL);
  const params = forStudentId != null && forStudentId !== "" ? { forStudentId } : {};
  return axios
    .get(`${apiBaseUrl}/api/stat/streak-kpi`, { params })
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

export async function getStudyTimeKpi(range, forStudentId = null) {
  return axios
    .get(`${import.meta.env.VITE_API_BASE_URL}/api/stat/study-time-kpi`, {
      params: paramsWithStudent(range, forStudentId),
    })
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

export async function getCategoryStats(forStudentId = null) {
  const apiBaseUrl = getApiUrl(import.meta.env.VITE_API_BASE_URL);
  const params = forStudentId != null && forStudentId !== "" ? { forStudentId } : {};
  return axios
    .get(`${apiBaseUrl}/api/stat/getStats`, { params })
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

export async function getWorstAndBestSubCategories(forStudentId = null) {
  const apiBaseUrl = getApiUrl(import.meta.env.VITE_API_BASE_URL);
  const params = forStudentId != null && forStudentId !== "" ? { forStudentId } : {};
  return axios
    .get(`${apiBaseUrl}/api/stat/worst-and-best`, { params })
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

export async function getAccuracyProgress(range, forStudentId = null) {
  const apiBaseUrl = getApiUrl(import.meta.env.VITE_API_BASE_URL);
  const config = forStudentId != null && forStudentId !== "" ? { params: { forStudentId } } : {};
  return axios
    .post(`${apiBaseUrl}/api/stat/accuracy`, { range: timeRange[range] }, config)
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

export async function getPointsEvolution(forStudentId = null) {
  const apiBaseUrl = getApiUrl(import.meta.env.VITE_API_BASE_URL);
  const params = forStudentId != null && forStudentId !== "" ? { forStudentId } : {};
  return axios
    .get(`${apiBaseUrl}/api/stat/points-evolution`, { params })
    .then((response) => response.data)
    .catch((err) => console.error(err));
}
